import { getPickemKey } from "db/info/pickemInfo";
import { Pickem } from "model/Pickem/Pickem";
import { RootState } from "app/store";

export const selectPickem = (
  state: RootState,
  tournamentId: string,
  pickemId: string
): Pickem | undefined => {
  const pickemKey = getPickemKey(tournamentId, pickemId);
  return state.user.pickems[pickemKey];
};
